import { restClient } from '@/Core'

import { ACTIVITY_REST_URL } from '../Contracts/Activity.types'
import { ownerCondition } from './LoadOwnerActivitiesTask'

import type { ActivityCountersResponse, ActivityOwnerKind } from '../Contracts/Activity.types'

/**
 * Лічильники рядка статусів вкладки — `GET /services/activities/counters` з
 * тим самим префільтром власника. Рахує той самий екшен, що й список
 * (`CountsByStatusTrait`), тож цифра на плашці = рядки після кліку.
 */
export const LoadOwnerActivityCountersTask = async (
    owner: ActivityOwnerKind,
    ownerUuid: string
): Promise<ActivityCountersResponse> => {
    const raw = await restClient.get(
        `${ACTIVITY_REST_URL}/counters?filters=${encodeURIComponent(
            JSON.stringify({ and: [ownerCondition(owner, ownerUuid)] })
        )}`,
        undefined,
        { forceRefresh: true }
    )

    return (raw ?? {}) as unknown as ActivityCountersResponse
}
